import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-workflow-host',
  templateUrl: './workflow-host.component.html',
  styleUrls: ['./workflow-host.component.scss']
})
export class WorkflowHostComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
